import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import carImage from "../assets/121.jpeg";
import usersIcon1 from "../assets/1.svg";
import savingsIcon2 from "../assets/3.svg";
import ecoIcon4 from "../assets/2.svg";

/* Icons */
const MapPinIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const UsersIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const TrendingDownIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
  </svg>
);
const LeafIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2C12 2 4 7 4 14c0 4 4 8 8 8s8-4 8-8c0-7-8-12-8-12z" />
  </svg>
);

const Home = () => {
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    interest: "Ride"
  });
const [submitted, setSubmitted] = useState(false);

  const handleStartRiding = () => {
    setShowModal(true);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  
const encode = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

const handleSubmit = (e) => {
  e.preventDefault();
if (!/^[6-9]\d{9}$/.test(formData.phone)) {
  alert("Please enter a valid Indian mobile number");
  return;
}

  fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: encode({
      "form-name": "drivve-early-access",
      ...formData
    })
  })
    .then(() => {
      setSubmitted(true);
    })
    .catch(error => alert(error));
};


  return (
    <div className="page">

      {/* HERO */}
      <section className="hero">
        <div className="hero-content">
          <h1>
            Seamless Carpooling app for <span className="highlight">Modern Commuters</span>
          </h1>

          <p style={{marginBottom:"20px"}}>
            Drivve&trade; helps you share rides, reduce costs, and travel smarter —
            all while lowering traffic and emissions.
          </p>
  <div className="hero-buttons">
  <button
    className="btn btn-primary"
    onClick={handleStartRiding}
  >
    Start Riding
  </button>

  <Link to="/download" className="btn btn-secondary">
    Download
  </Link>

  <Link to="/survey" className="btn btn-secondary feedback-btn">
    Submit Your Feedback
  </Link>
</div>

        </div>

        <div className="about-image">
          <img
            src={carImage}
            alt="Drivve Car"
    className="about-car-image"
          />
        </div>
      </section>

      {/* FEATURES */}
      <section className="features">
        <h2>Why Choose <span className="highlight">Drivve&trade;</span>?</h2>

        <div className="features-grid">
          <div className="feature-card">
            <MapPinIcon />
            <h3>Smart Route Matching</h3>
            <p>
              Matches riders and drivers traveling the same route with minimal detours.
            </p>
          </div>

          <div className="feature-card">
            <TrendingDownIcon />
            <h3>Lower Travel Costs</h3>
            <p>
              Share fuel and toll expenses to save up to 60% on your daily commute.
            </p>
          </div>

          <div className="feature-card">
            <ShieldIcon />
            <h3>Safe & Verified</h3>
            <p>
              Verified profiles, live tracking feature, and trusted ride partners.
            </p>
          </div>

          <div className="feature-card">
            <UsersIcon />
            <h3>Community Driven</h3>
            <p>
             Share your commute with people you can rely on.
            </p>
          </div>
        </div>
      </section>

      {/* STATS */}
     <section
  style={{
    padding: "70px 6vw",
    background: "#FAFBFC",
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "40px",
      textAlign: "center",
    }}
  >

    {/* Users */}
    <div style={{ flex: "1 1 180px" }}>
      <img src={usersIcon1} alt="Users" style={statIcon} />


      <p style={{ color: "rgba(19,15,15,0.7)" }}>
        Rapidly Growing Users
      </p>
    </div>


    {/* Savings */}
    <div style={{ flex: "1 1 180px" }}>
      <img src={savingsIcon2} alt="Savings" style={statIcon} />

   
      <p style={{ color: "rgba(19,15,15,0.7)" }}>
        Reduced Costs Per Ride
      </p>
    </div>


    {/* Verified */}
    <div style={{ flex: "1 1 180px" }}>
    
      <h3 style={{ fontSize: "28px", color: "#184080" }}>
        100%
      </h3>

      <p style={{ color: "rgba(19,15,15,0.7)" }}>
        Verified Profiles
      </p>
    </div>


    {/* Eco */}
    <div style={{ flex: "1 1 180px" }}>
      <img src={ecoIcon4} alt="Eco Friendly" style={statIcon} />

      

      <p style={{ color: "rgba(19,15,15,0.7)" }}>
        Eco Friendly Commute
      </p>
    </div>

  </div>
</section>


{/* EARLY ACCESS MODAL */}
{showModal && (
  <div style={styles.overlay}>
    <div style={styles.modal}>

      {/* CLOSE BUTTON */}
      <button
        style={styles.closeBtn}
        onClick={() => setShowModal(false)}
      >
        ✕
      </button>

      {/* Coming Soon Badge */}
      <div style={styles.badge}>
        App Coming Soon
      </div>

      <h2 style={styles.title}>Be First on the Road with Drivve</h2>

      <p style={{color:"#130f0f",marginBottom:"0rem"}}>
        Be the first to experience smarter carpooling with Drivve™.
      </p>

     {submitted ? (

  <div style={styles.successBox}>

 
    <p style={styles.successText}>
      Thanks for joining <strong>Drivve™</strong>.<br/>
      We're getting ready to launch soon.
      Stay tuned!
    </p>

    <button
      style={styles.gotItBtn}
      onClick={() => {
        setShowModal(false);
        setSubmitted(false); // reset for next open
        document.body.style.overflow = "auto";
      }}
      onMouseOver={(e)=>{
        e.currentTarget.style.background="#12316b";
        e.currentTarget.style.transform="translateY(-2px)";
      }}
      onMouseOut={(e)=>{
        e.currentTarget.style.background="#184080";
        e.currentTarget.style.transform="translateY(0)";
      }}
    >
      Got it
    </button>

  </div>

) : (

  <form onSubmit={handleSubmit}>

<input
  type="text"
  name="name"
  placeholder="Full Name"
  required
  value={formData.name}
  minLength={2}
  pattern="^[A-Za-z ]+$"
  style={styles.input}

  onChange={(e) => {
    let value = e.target.value.replace(/[^A-Za-z ]/g, "");
    value = value.replace(/\s{2,}/g, " ");

    setFormData({
      ...formData,
      name: value
    });
  }}

  onInvalid={(e) =>
    e.target.setCustomValidity("Please enter a valid full name")
  }

  onInput={(e) => e.target.setCustomValidity("")}
/>


       <input
  type="tel"
  name="phone"
  placeholder="Enter WhatsApp Number"
  required
  maxLength={10}
  pattern="[6-9][0-9]{9}"
  inputMode="numeric"
  autoComplete="tel"
  value={formData.phone}
  style={styles.input}

  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, "");

    // Block invalid starting digits
    if (value.length === 1 && !/[6-9]/.test(value)) {
      return;
    }

    setFormData({
      ...formData,
      phone: value
    });
  }}

  onInvalid={(e) =>
    e.target.setCustomValidity(
      "Enter a valid 10-digit Indian mobile number starting with 6-9"
    )
  }

  onInput={(e) => e.target.setCustomValidity("")}
/>


          <p style={styles.label}>Interested In:</p>

          <div style={{ marginBottom: "22px" }}>
            {["Ride", "Drive", "Both"].map(option => (
              <label key={option} style={styles.radio}>
               <input
  type="radio"
  name="interest"
  value={option}
  checked={formData.interest === option}
  onChange={handleChange}
  style={{ marginRight: "8px" }}
/>

                {option}
              </label>
            ))}
          </div>

          <button type="submit" style={styles.submitBtn}>
            Join Drivve
          </button>

        </form>

      )}
      {/* ✅ CONDITIONAL END */}

    </div>
  </div>
)}



    </div>
  );
};

/* ---------- MODAL STYLES ---------- */
const styles = {

  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(19,15,15,0.65)",
    backdropFilter: "blur(8px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
zIndex: 9999
  },

  modal: {
  position: "relative",
  background: "#ffffff",
  padding: "38px",
  borderRadius: "18px",
  width: "92%",
  maxWidth: "480px", // ⭐ CRITICAL (prevents fullscreen look)

  boxShadow: "0 40px 120px rgba(19,15,15,0.18)"
},

  closeBtn: {
    position: "absolute",
    top: "14px",
    right: "16px",
    border: "none",
    background: "transparent",
    fontSize: "22px",
    cursor: "pointer",
    color: "#130F0F",
    fontWeight: "bold"
  },

  badge: {
    display: "inline-block",
    background: "rgba(24,64,128,0.1)",
    color: "#184080",
    padding: "6px 16px",
    borderRadius: "999px",
    fontWeight: "700",
    fontSize: "13px",
    marginBottom: "14px"
  },

  title: {
    fontSize: "26px",
    fontWeight: "800",
    marginBottom: "6px",
    color: "#130F0F"
  },

  subtitle: {
    color: "#555",
    marginBottom: "22px",
    lineHeight: "1.5"
  },

  input: {
    width: "100%",
    padding: "14px",
    marginTop: "12px",
    borderRadius: "12px",
    border: "1.5px solid #e6e6e6",
    outline: "none",
    fontSize: "15px"
  },

  label: {
    marginTop: "16px",
    fontWeight: "700",
    color: "#130F0F"
  },

  radio: {
    marginRight: "18px",
    color: "#333",
    fontWeight: "500"
  },

  submitBtn: {
    width: "100%",
    padding: "15px",
    borderRadius: "14px",
    border: "none",
    background: "#184080",
    color: "white",
    fontSize: "16px",
    cursor: "pointer",
    marginTop: "10px"
  },
successBox: {
  textAlign: "center",
  padding: "20px 10px"
},
successTitle: {
  color: "#184080",
  fontSize: "26px",
  fontWeight: "800",
  marginBottom: "10px"
},
successText: {
  color: "#130f0f",
  fontSize: "18px",
  lineHeight: "1.6"
},
gotItBtn: {
  marginTop: "26px",
  padding: "14px 38px",
  borderRadius: "40px",
  border: "none",
  background: "#184080",
  color: "#fff",
  fontSize: "16px",
  fontWeight: "700",
  cursor: "pointer",
  transition: "0.25s ease",
},

};
const statIcon = {
  width: "38px",
  height: "38px",
  objectFit: "contain",
  marginBottom: "10px",
};

export default Home;
